import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ShoppingCart, User, Menu, X, ChevronDown } from 'lucide-react';
import ConsultiumLogo from './ConsultiumLogo';

const Navbar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isLoggedIn = localStorage.getItem('user');
  const user = isLoggedIn ? JSON.parse(localStorage.getItem('user')) : null;

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-3">
            <ConsultiumLogo size="default" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-emerald-600 transition-colors font-medium">
              HOME
            </Link>
            <Link to="/#popular" className="text-gray-700 hover:text-emerald-600 transition-colors font-medium">
              SERVICES
            </Link>
            <Link to="/faqs" className="text-gray-700 hover:text-emerald-600 transition-colors font-medium" data-testid="nav-info">
              INFO
            </Link>
            <Link to="/blog" className="text-gray-700 hover:text-emerald-600 transition-colors font-medium" data-testid="nav-blog">
              RESOURCES
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-emerald-600 transition-colors font-medium" data-testid="nav-contact">
              CONTACT
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            {isLoggedIn ? (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-gray-700">Hello, {user?.name}</span>
                <Button onClick={() => navigate('/dashboard')} variant="outline" size="sm">
                  Dashboard
                </Button>
                <Button onClick={handleLogout} variant="ghost" size="sm">
                  Logout
                </Button>
              </div>
            ) : (
              <Button onClick={() => navigate('/login')} className="bg-emerald-600 hover:bg-emerald-700">
                Login
              </Button>
            )}

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors">
                HOME
              </Link>
              <Link to="/#popular" className="text-gray-700 hover:text-red-600 transition-colors">
                SERVICES
              </Link>
              <Link to="/faqs" className="text-gray-700 hover:text-red-600 transition-colors" data-testid="nav-info-mobile">
                INFO
              </Link>
              <Link to="/blog" className="text-gray-700 hover:text-red-600 transition-colors" data-testid="nav-blog-mobile">
                RESOURCES
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-red-600 transition-colors" data-testid="nav-contact-mobile">
                CONTACT
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
